import { render, staticRenderFns } from "./ModalLogsSuporteUsuarios.vue?vue&type=template&id=2ac23b4e&scoped=true"
import script from "./ModalLogsSuporteUsuarios.vue?vue&type=script&lang=ts"
export * from "./ModalLogsSuporteUsuarios.vue?vue&type=script&lang=ts"
import style0 from "./ModalLogsSuporteUsuarios.vue?vue&type=style&index=0&id=2ac23b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac23b4e",
  null
  
)

export default component.exports